import React, {useContext} from "react";
import Footer from "../Components/Footer";
import ThemeContext from "../Theme/ThemeContext";

export interface HomepageProps {
    title : string
    subtitle : string
    buttons : JSX.Element[]
    onCancel: () => void
}

export default function Homepage(props : HomepageProps) {

    const theme = useContext(ThemeContext)

    return <div className="homepage">
        <div className="top-header">
            <img src={theme.homeTopImage} alt=""/>
            <div className="logo">
                <img src="images/shared/logo.png" alt=""/>
            </div>
        </div>
        <div className="content">
            <h1>{props.title}</h1>
            <h2>{props.subtitle}</h2>
            <div className="buttons">
                {props.buttons}
            </div>
        </div>
        <Footer />
    </div>
}